import React from "react";

export default function RozarPayPaymentStatus() {
  return (
    <div>
      <p>RozarPayPaymentStatus</p>
    </div>
  );
}
